import {Component, inject, OnDestroy} from '@angular/core';
import {
  RecordsTableContainerComponent
} from "../../../core/components/records-table-container/records-table-container.component";
import {ResourceParams, resources} from "../../../core/models/resource/resources";
import {TablePageComponent} from '../pages-base/table-page.component';
import {ActivatedRoute} from "@angular/router";
import {UrlQueryParamsStateService} from "../../../core/services/table-services/url-query-params-state.service";
import {TableContextService} from "../../../core/services/table-services/table-context.service";
import { PageInfoComponent } from "../../../core/components/page-info/page-info.component";

@Component({
  selector: 'app-hypotheses-page',
  imports: [
    RecordsTableContainerComponent,
    PageInfoComponent
  ],
  templateUrl: './hypotheses-page.component.html',
  styleUrl: './hypotheses-page.component.scss',
  providers: [ TableContextService ]
})
export class HypothesesPageComponent extends TablePageComponent implements OnDestroy {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private urlQueryParamsStateService: UrlQueryParamsStateService = inject(UrlQueryParamsStateService);

  public readonly resourceParams: ResourceParams = resources['hypotheses'];

  public override ngOnInit(): void {
    super.ngOnInit();
    this.setUrlQueryParamsState();
  }

  public ngOnDestroy(): void {
    this.urlQueryParamsStateService.resetUrlQueryParamsState();
  }

  private setUrlQueryParamsState(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const allParams = {} as Record<string, string | null>;
      params.keys.forEach(key => {
        allParams[key] = params.get(key);
      });

      this.urlQueryParamsStateService.setUrlQueryParamsState(allParams);
    });
  }
}
